import { combineReducers } from 'redux';

import { REQUEST_ASSOCIATION, SUCCESS_ASSOCIATION, FAILURE_ASSOCIATION } from './constants';

const associations = (state = [], action) => {
    switch (action.type) {
        case SUCCESS_ASSOCIATION:
            return action.response.payload;
        case REQUEST_ASSOCIATION:
        case FAILURE_ASSOCIATION:
            return [];
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_ASSOCIATION:
            return true;
        case FAILURE_ASSOCIATION:
        case SUCCESS_ASSOCIATION:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_ASSOCIATION:
            return action.response.message;
        case REQUEST_ASSOCIATION:
        case SUCCESS_ASSOCIATION:
            return '';
        default:
            return state;
    }
};

export default combineReducers({ associations, fetching, error });



// WEBPACK FOOTER //
// ./src/services/association/reducer.js